import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { environment } from 'src/environments/environment';
import { ModalShareComponent } from '../../blocks/modal-share/modal-share.component';

@Component({
  selector: 'app-sample-events',
  templateUrl: './sample-events.component.html',
  styleUrls: ['./sample-events.component.scss']
})
export class SampleEventsComponent implements OnInit {

  @Input() block: any;
  @Input() lang: string = '';
  public domainWebsite = environment.urlApi;
  public allEvents: any[] = [];
  public eventsDataArrayBig: any;
  public eventsDataArraySmall: any;
  public eventsDataArrayAll: any;
  public altImage: string = '';
  public widthImage: string = '';
  public heightImage: string = '';
  public headerData = {
    titolo: '',
    labelLink: '',
    labelLinkUrl: ''
  };
  public eventDate!: {
    inizio: string;
    fine: string | null;
  };

  customOptionsNews: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    responsive: {
      0: {
        items: 1
      }
    },
    nav: false
  }

  constructor(
    public nodeService: NodeService,
    private modalService: NgbModal,
    public navigationService: NavigationService
  ) { }


  ngOnInit(): void {
    this.getEvents();
    this.setHeaderData();
  }

  public setLabelCategoryBig(category: any): string {
    let stingCategory: string = '';
    if (category.length > 3) {
      stingCategory = category[0].name + ', ' + category[1].name + ', ' + category[2].name + ', ' + '+' + (category.length - 3);
    } else {
      category.forEach((el: any, idx: number) => {
        if (idx === category.length - 1) {
          stingCategory += el.name;
        } else {
          stingCategory += el.name + ', ';
        }
      });
    }
    return stingCategory;
  }

  getEvents(): void {
    this.nodeService.getRowTypeView(this.lang, this.block.oggetto_view, this.block.tipo_view, this.block.preview).subscribe(eventsData => {
      this.allEvents = eventsData;
      // for desktop
      this.eventsDataArrayBig = eventsData[0];
      this.eventsDataArraySmall = eventsData.slice(0, 3);
      this.eventsDataArraySmall.shift();
      // for mobile
      if (eventsData.length > 4) {
        this.eventsDataArrayAll = eventsData.slice(0, 3);
      } else {
        this.eventsDataArrayAll = eventsData;
      }
      this.setDate(this.eventsDataArrayBig);
    });
  }

  public setImage(field_image: string): string {
    this.altImage = this.nodeService.retrieveImage(field_image, 'alt');
    this.widthImage = this.nodeService.retrieveImage(field_image, 'width');
    this.heightImage = this.nodeService.retrieveImage(field_image, 'height');
    return this.domainWebsite + this.nodeService.retrieveImage(field_image, 'src');
  }

  private setDate(event: any): void {
    if (this.nodeService.retrieveDateTime(event.field_data_inizio, 'datetime') === this.nodeService.retrieveDateTime(event.field_data_fine, 'datetime')) {
      this.eventDate = {
        inizio: this.nodeService.retrieveDateTime(event.field_data_inizio, 'datetime'),
        fine: null
      }
    } else {
      this.eventDate = {
        inizio: this.nodeService.retrieveDateTime(event.field_data_inizio, 'datetime'),
        fine: this.nodeService.retrieveDateTime(event.field_data_fine, 'datetime')
      }
    }
  }

  public setTitle(field_titolo: string): any {
    return this.nodeService.retriveLinkTagA(field_titolo, 'a');
  }

  private setHeaderData(): void {
    this.headerData = {
      titolo: this.block.titolo,
      labelLink: this.block.label_link,
      labelLinkUrl: ''
    }
    if (this.block.link) {
      this.headerData = {
        ...this.headerData,
        labelLinkUrl: this.block.link.url
      }
    }
  }

  public openModaleShare(): void {
    const modalRef = this.modalService.open(ModalShareComponent, {
      scrollable: false,
      centered: true,
      size: 'lg',
    });
    let data: any;
    const path: string = this.nodeService.retriveLinkTagA(this.eventsDataArrayBig.field_titolo, 'a').link;
    data = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${path}`,
      twitter: `http://twitter.com/share?text=Im%20sharing%20on%20Twitter&url=${path}`,
      linkedin: `https://linkedin.com/sharing/share-offsite/?url=${path}`,
      copy_text: path
    };
    modalRef.componentInstance.fromParent = data;
  }

}
